import {useUserProfileQuery} from '@/features/account-settings';
import {useUserDetails} from '@/lib/auth';

import type {UserProfileDTO} from '@sollapay/types';

export interface CurrentUserIdentity {
  userId: string | undefined;
  displayName: string;
  email: string | undefined;
  pictureUrl: string | undefined;
  /** Full profile DTO, when loaded — avoids a second `useUserProfileQuery` call at consumers. */
  profile: UserProfileDTO | undefined;
}

/** Single source of truth for the current user's own display identity — use this, never `useUserDetails`, directly. */
export function useCurrentUserIdentity(): CurrentUserIdentity {
  const {user, name, email, picture} = useUserDetails();
  const {data: profile} = useUserProfileQuery();
  const userId = user?.sub;

  if (profile) {
    return {
      userId,
      displayName: profile.displayName,
      email: profile.email || email,
      pictureUrl: profile.avatarUrl ?? undefined,
      profile
    };
  }

  return {
    userId,
    displayName: name ?? email ?? '',
    email,
    pictureUrl: picture,
    profile: undefined
  };
}
